<div class="terms-conditions" data-oa-el-id="sega">
  <!--THE LANDOWNER'S TERMS AND CONDITIONS-->

  @if (initializing) {
    <spinner messageRelativePosition="bottom"> </spinner>
  }

  @if (landOwnerTerms !== undefined && (landOwnerTerms.propertyRules.length > 0)) {
    <div
      class="text-center"
      >
      <h4>Land Owner's Terms & Conditions</h4>
      @if (!initializing) {
        @if (landOwnerTerms.propertyRules.length > 0) {
          <p [innerHTML]="$safeNavigationMigration(landOwnerTerms?.propertyRules) | newlineToParagraph"></p>
        }
      }
    </div>
  }

  <div class="text-center">
    <h4>Outdoor Access Terms and Conditions</h4>
    <p>
      {{ oaTermsAndConditionText }}
    </p>
  </div>

  <div class="terms">
    By continuing, I agree to Outdoor Access's cancellation policy, Outdoor Access's
    <a href="user/agreement" target="terms">terms and conditions</a> and the landowner's terms and conditions.
  </div>

  <div class="btn-continue">
    <button
      [disabled]="initializing"
      id="booking-terms-i-agree-button"
      type="button"
      class="btn btn-primary btn-lg btn-lg-round btn-block"
      (click)="onAgreeClick()"
      >
      @if (loading) {
        <i class="fa fa-circle-notch fa-spin"></i>
      }
      I Agree
    </button>
  </div>
</div>
